import * as Sentry from '@sentry/react';
import getException from './getException';

const getMessageFromException = (exception: Sentry.Exception) => {
    const { type, value: exceptionMessage } = exception;
    return `${type}: ${exceptionMessage}`;
};

const parseEventMessage = (event: Sentry.Event) => {
    const exception = getException(event);
    return exception ? getMessageFromException(exception) : event.message;
};

export default parseEventMessage;
